import React from "react";
import { Link as ScrollLink } from "react-scroll";

// const aboutData = {
//   cvpath: "media/empty.pdf",
//   image: "images/about.png",
//   name: "Zafirul Islam",
//   location: "Delhi,India",
//   birthday: "22",
//   email: "universal.zafkhan2001@gmail.com",
//   aboutMe:
//     "I'm Zafirul Islam , a FullStack Web Developer from Delhi,India. I have rich experience in Website design and building Web App , I  Worked on Like (' Hr Management System - Tour & Travels - LMS - Componet based Web APP ') I believe in understanding each client's unique needs and goals. By listening attentively, I develop tailored solutions that exceed expectations and deliver tangible results. My approach combines expertise with a creative mindset, constantly seeking innovative strategies to stay ahead in Web Development  ",
// };
const birthYear = 2001;
const currentAge = new Date().getFullYear() - birthYear;

const aboutData = {
  cvpath: "media/empty.pdf",
  image: "images/about.png",
  name: "Zafirul Islam",
  location: "Delhi,India",
  birthday: currentAge,
  email: "zafirulislam1999@gmail.com",
  aboutMe: `
  I'm <strong>Zafirul Islam</strong>, a highly skilled <strong>FullStack Web Developer</strong> based in <strong>Delhi, India</strong>.
  <br />
  <br />
  With my extensive experience in website design and building web applications, I have successfully worked on projects such as :
  <ul style="font-weight:bold">
  <li>HR Management Systems</li>
  <li>Tour & Travel Web Application</li>
  <li>Learning Management Systems (LMS)</li>
  <li>component-based web applications</li>
  <li>Multi Vendor E commerce </li>
  <li>Medical Tourism WebSites</li>
  <li>Portfolio Websites</li>
  And many more
  </ul>
   <span style="color:blue; font-weight:bold"> I strongly believe</span> in the importance of understanding each client's unique needs and goals. By actively listening to my clients, <strong> I am able to develop tailored solutions that not only meet but exceed their expectations</strong>.
  <br />
  <br />

  <p>I am <span style="color:blue; font-weight:bold">passionate</span> about my work and dedicated to providing exceptional services to my clients.When it comes to creating an amazing website or creating an advanced web application, I'm committed to providing top-quality solutions to help my customers achieve success in the digital world 
  <mark style="background-color:yellow; font-weight:bold;">Choose me as your web development partner, and together we can turn your ideas into reality, bringing your online presence to new heights.</mark></p>
   
  `
};
// My main goal is to provide real results, which <strong>positively impact their businesses</strong>. My approach to web development is to combine technical knowledge along with an innovative mindset.I always try to keep up with the constantly evolving area of development for websites by pursuing new strategies and using the most advanced technology. This ensures that the websites and web applications  This assures that the websites and applications I create are not just visually pleasing but also extremely efficient and user-friendly.
// <br />
// <br />


function About() {
  return (
    <div className="row">
      <div className="col-md-3 aboutimage">
        <img src={aboutData.image} alt={aboutData.name} />
      </div>
      <div className="col-md-9">
        <h2 className="mt-4 mt-md-0 mb-4">Hello,</h2>
        {/* <p className="mb-0">{aboutData.aboutMe}</p> */}
        <p className="mb-0" dangerouslySetInnerHTML={{ __html: aboutData.aboutMe }}></p>
        <div className="row my-4">
          <div className="col-md-6">
            <p className="mb-2">
              Name: <span className="text-dark">{aboutData.name}</span>
            </p>
            <p className="mb-0">
              Age: <span className="text-dark">{aboutData.birthday}</span>
            </p>
          </div>
          <div className="col-md-6 mt-2 mt-md-0 mt-sm-2">
            <p className="mb-2">
              Location: <span className="text-dark">{aboutData.location}</span>
            </p>
            <p className="mb-0">
              Email: <span className="text-dark">{aboutData.email}</span>
            </p>
          </div>
        </div>
        <a href={aboutData.cvpath} className="btn btn-default mr-2">
          <i className="icon-cloud-download"></i>Download CV
        </a>
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-alt mt-md-0 mt-xs-2"
        >
          <i className="icon-envelope"></i>Hire me
        </ScrollLink>
      </div>
    </div>
  );
}

export default About;
